/**
 * @license lucide v0.356.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const Radical = ["svg", defaultAttributes, [["path", { d: "M3 12h4l3 9 4-17h7" }]]];

export { Radical as default };
//# sourceMappingURL=radical.js.map
